import IconMembershipFloatingCta from '@/assets/icons/Membership/IconMembershipFloatingCta.svg?react';
import { useAppSelector } from '@/redux/store';
import useWebview from '@/hooks/V3/useWebview';
import { useSearchParams } from 'react-router-dom';
import { PC_HERO_BADGE_FIRST_PAYMENT_TYPE } from '@/pages/mobile-membership/mobile-membership-utils';
import { useMobileMembershipPolicy } from '@/pages/mobile-membership/use-mobile-membership-policy';

import {
  buildStatisticsPreviewMembershipUrl,
  getStatisticsPreviewMembershipCtaCopy,
} from './statistics-preview-membership-cta';

const StatisticsPreviewMembershipCTA = () => {
  const { CplatToken } = useAppSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const { postMessage } = useWebview();
  const { policy } = useMobileMembershipPolicy();
  const isFirstPaymentUser =
    policy.pcHeroBadge.type === PC_HERO_BADGE_FIRST_PAYMENT_TYPE || policy.isPrePayment;
  const copy = getStatisticsPreviewMembershipCtaCopy(new Date(), {
    isFirstPaymentUser,
  });
  const membershipUrl = buildStatisticsPreviewMembershipUrl(
    CplatToken || searchParams.get('cplatToken'),
  );

  const handleClick = () => {
    if (window.ReactNativeWebView) {
      postMessage({
        action: 'openExternal',
        data: membershipUrl,
      });
      return;
    }

    window.open(membershipUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-20 bg-gradient-to-b from-wh/0 from-[0%] via-wh via-[50%] to-wh px-[20px] pb-[23px] pt-[88px]">
      <button
        type="button"
        aria-label="멤버십 혜택 페이지로 이동"
        className="pointer-events-auto flex min-h-[68px] w-full items-center gap-[8px] rounded-[10px] bg-gr-50 p-[16px] text-left"
        data-membership-preview-interactive="true"
        onClick={handleClick}
      >
        <IconMembershipFloatingCta aria-hidden className="h-[36px] w-[36px] flex-none" />
        <span className="flex min-w-0 flex-1 flex-col gap-[2px]">
          <span className="truncate text-gr-800 Body3S15">{copy.title}</span>
          <span className="truncate text-gr-600 Caption1M12">{copy.description}</span>
        </span>
      </button>
    </div>
  );
};

export default StatisticsPreviewMembershipCTA;
